import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

export enum DesktopAppEvent {
    /** @deprecated */
    USE_TODESKTOP_APP = "use_todesktop_app",

    // General event logged when the based desktop app component renders
    USE_TODESKTOP_BUILDER_APP = "use_todesktop_builder_app",
    // More events specific to desktop app actions.
    MENUBAR_TRAY_CLICK = "menubar_tray_click",
    NOTIFICATION_CLICK_EVENT = "notification_click",
}

enum DesktopAppEventProperties {
    ACTION = "action",
}

/**
 * @deprecated
 */
export class UseToDesktopAppEvent extends AmplitudeEvent {
    constructor() {
        super(DesktopAppEvent.USE_TODESKTOP_APP);
    }
}

interface ToDesktopAppEventDetails {
    appVersion: string;
}

export class UseToDesktopBuilderAppEvent extends AmplitudeEvent {
    constructor(eventProps: ToDesktopAppEventDetails) {
        super(DesktopAppEvent.USE_TODESKTOP_BUILDER_APP);
        this.props = { ...eventProps };
    }
}

export class MenubarTrayClick extends AmplitudeEvent {
    constructor(eventProps: ToDesktopAppEventDetails) {
        super(DesktopAppEvent.MENUBAR_TRAY_CLICK);
        this.props = { ...eventProps };
    }
}

export class NotificationClickEvent extends AmplitudeEvent {
    constructor(method: "join_meeting" | "open_window") {
        super(DesktopAppEvent.NOTIFICATION_CLICK_EVENT);
        this.props = { [DesktopAppEventProperties.ACTION]: method };
    }
}
